import * as React from 'react';

import c4gLogo from 'images/ent-website/c4g-logo.svg';

import _t from 'i18n!nls/ent-website';

function C4GLogo() {
  return <img src={c4gLogo} width={240} alt={_t('Coursera for Government')} />;
}

export default C4GLogo;
